const pintarContactInfo = {
  contactNo: '+923000746827',
  email: "operations@pintar.pk",
  supportEmail: "support@pintar.pk",
  // address: "B-35, Block 15, Gulistan e Jahor, Karachi, Pakistan",
  address: "Karachi, Pakistan",
  addressLink: "https://www.google.com/maps/place/Karachi,+Karachi+City,+Sindh,+Pakistan/@25.1921465,66.5949847,9z/data=!3m1!4b1!4m5!3m4!1s0x3eb33e06651d4bbf:0x9cf92f44555a0c23!8m2!3d24.8607343!4d67.0011364"
};

export default pintarContactInfo;